import PropTypes from "prop-types";
import React from "react";

export const ExclamationDanger = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path
        className="cls-1"
        d="m16,23c.42,0,.78-.14,1.06-.44.28-.28.44-.64.44-1.06s-.14-.78-.44-1.06c-.28-.28-.64-.44-1.06-.44s-.78.14-1.06.44c-.28.28-.44.64-.44,1.06s.14.78.44,1.06c.28.28.64.44,1.06.44Zm-1.5-6h3V9h-3v8Zm1.5,14c-2.08,0-4.04-.4-5.88-1.19-1.83-.78-3.44-1.86-4.78-3.21-1.35-1.37-2.43-2.97-3.21-4.78-.79-1.83-1.19-3.79-1.19-5.88s.4-4.04,1.19-5.88c.78-1.83,1.86-3.44,3.21-4.78,1.37-1.35,2.97-2.43,4.78-3.21,1.83-.79,3.79-1.19,5.88-1.19s4.04.4,5.88,1.19c1.83.78,3.44,1.86,4.78,3.21,1.37,1.37,2.43,2.97,3.21,4.78.79,1.83,1.19,3.79,1.19,5.88s-.4,4.04-1.19,5.88c-.78,1.83-1.86,3.44-3.21,4.78s-2.97,2.43-4.78,3.21c-1.83.79-3.79,1.19-5.88,1.19Zm0-3c3.37,0,6.21-1.17,8.56-3.5,2.33-2.33,3.5-5.19,3.5-8.56s-1.17-6.21-3.5-8.56c-2.33-2.33-5.19-3.5-8.56-3.5s-6.21,1.17-8.56,3.5c-2.33,2.33-3.5,5.19-3.5,8.56s1.17,6.21,3.5,8.56c2.33,2.33,5.19,3.5,8.56,3.5Z"
      />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      style,
      viewBox: "0 0 32 32",
    };
  }
};

ExclamationDanger.displayName = "ExclamationDangerIcon";

ExclamationDanger.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

ExclamationDanger.defaultProps = {
  role: "img",
};
